import React from 'react';
import { useUiStore } from '../../store/uiSlice';
import { clsx } from 'clsx';
import { Button } from './Button';

export const NotificationContainer: React.FC = () => {
  const { notifications, removeNotification } = useUiStore();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-20 right-4 z-50 space-y-2 max-w-sm">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={clsx(
            'p-4 rounded-lg shadow-lg backdrop-blur-sm border animate-fadeIn',
            {
              'bg-green-900/80 border-green-700/50 text-green-100':
                notification.type === 'success',
              'bg-red-900/80 border-red-700/50 text-red-100':
                notification.type === 'error',
              'bg-yellow-900/80 border-yellow-700/50 text-yellow-100':
                notification.type === 'warning',
              'bg-blue-900/80 border-blue-700/50 text-blue-100':
                notification.type === 'info',
            }
          )}
        >
          <div className="flex items-start">
            <div className="flex-shrink-0">
              {notification.type === 'success' && (
                <svg
                  className="h-6 w-6 text-green-100"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              )}
              {notification.type === 'error' && (
                <svg
                  className="h-6 w-6 text-red-100"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
              {notification.type === 'warning' && (
                <svg
                  className="h-6 w-6 text-yellow-100"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.5 0H6.228c-.536 0-1.033.208-1.424.524l4.352 4.352c.416.416.904.624 1.424.624h5.476c.52 0 1.008-.208 1.424-.624l4.352-4.352c.416-.416.624-.904.624-1.424V6.228c0-.536-.208-1.033-.524-1.424L13.732 4c-.77-.833-1.964-.833-2.5 0H6.228c-.536 0-1.033.208-1.424.524l4.352 4.352c.416.416.904.624 1.424.624h5.476c.52 0 1.008-.208 1.424-.624l4.352-4.352c.416-.416.624-.904.624-1.424.624z"
                  />
                </svg>
              )}
              {notification.type === 'info' && (
                <svg
                  className="h-6 w-6 text-blue-100"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              )}
            </div>
            
            <div className="ml-3 flex-1">
              <p className="text-sm font-medium">
                {notification.title}
              </p>
              <p className="text-sm mt-1">
                {notification.message}
              </p>
            </div>
            
            <div className="ml-auto pl-3">
              <div className="-mx-1.5 -my-1.5">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => removeNotification(notification.id)}
                  className="p-1 text-current opacity-70 hover:opacity-100"
                >
                  <span className="sr-only">Dismiss</span>
                  <svg
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </Button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};